import i18n from 'i18next';
import { configEnv } from 'util/config-file';
import { lsm, StoreObservable } from './store-manager';

const LANGUAGE_KEY = 'VKYC_LANGUAGE';
const DEFAULT_LANG = configEnv.get().language;

class LanguageStore {
  private LANGUAGE_DEFAULT: string = DEFAULT_LANG;

  private store: StoreObservable<string>;

  constructor() {
    this.store = lsm.getStoreObservable(LANGUAGE_KEY);
    this.store.setDefault(() => this.LANGUAGE_DEFAULT);
  }

  public getLan() {
    return this.store.getNotNull();
  }

  public getLanName() {
    const result = configEnv.get().languageArr.filter((item) => item.key === this.getLan());
    return result.length ? result[0].name : '';
  }

  public changeLan() {
    const result = configEnv.get().languageArr.filter((item) => item.key !== this.getLan());
    this.setLan(result.length ? result[0].key : '');
  }

  public setLan = (language: string) => {
    try {
      const lang = configEnv.containLang(language) ? language : DEFAULT_LANG;
      this.updateData(lang);
    } catch {
      this.updateData(DEFAULT_LANG);
    }
  };

  public clearData = () => {
    this.store.clear();
  };

  private updateData = (language: string) => {
    i18n.changeLanguage(language);
    console.log('Save language', language);
    this.store.set(language);
  };
}

const langStore = new LanguageStore();
export default langStore;
